module.exports = __webpack_public_path__ + "img/climate_actions_paper@2x.89f433c.webp";